export default __webpack_public_path__ + "static/media/plain-sticker-h.06e2fd11.png";